import { useDispatch } from 'react-redux';
import {
    STORE_SURGERY_DETAILS,
    GET_USAGE_DETAILS,
    SET_PATIENT_DETAILS,
    SET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_CURRENT_STEP,
    RESET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_EDIT_MODE,
    GET_PRICES_FOR_ITEMS,
    GET_DROPDOWN_OPTIONS,
    GET_DISTRICT_TERRITORY,
    GET_PROCEDURE_INFO,
    VALIDATE_PRODUCT_DETAILS,
    VALIDATE_UNID_PLAN_FEE_ITEMS,
    VALIDATE_REPLEN_PRODUCTS,
    USAGE_ATTACHMENT_UPLOAD,
    CREATE_USAGE_ORDER,
    UPDATE_USAGE_ORDER,
    USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    RESET_PO_ATTACHMENT,
    GET_IMAGE_PO_PREVIEW,
    DELETE_ATTACHMENT_REQUEST,
    VALIDATE_MAZOR_CODE,
    SET_SELECT_ACCOUNT,
    STORE_ITEM_TABLE_DATA,
    RESET_REPORT_USAGE_STATES,
    RESET_VALIDATED_DATA,
    SET_ALL_ACCOUNT_OWNED_SELECTED,
    SET_PROCEDURE_DETAILS,
    SET_UNID_SELECTED,
    SAVE_OR_REPORT_DATA,
    CLEAR_SPECFIC_DROPDOWN_LIST,
    RESET_IMAGE_PO_PREVIEW,
    RESET_DROPDOWN_OPTIONS,
    SHOW_UNSAVED_REPORT_USAGE_CHANGES_POP_UP,
    SHOW_NO_USAGE_OR_CANCEL_SURGERY_POPUP,
    CANCEL_USAGE_ORDER,
    SET_PRICEOVERRIDE_DETAILS,
    GET_SHIPPING_METHODS_REPORT_USAGE,
    RESET_REPLENE_SHIPPING_METHOD,
    CLEAR_OUTSIDE_SHIPPING_ADDRESS,
    GET_SHIP_TO_ADDRESS_REPORT_USAGE,
    GET_OUTSIDE_ACCOUNT,
    CLEAR_INSIDE_SHIPPING_ADDRESS,
    SET_USAGE_SURGERY_DETAIL_INSIDE,
    SET_USAGE_SURGERY_DETAIL_OUTSIDE,
    GET_DISCREPANCY_DATA,
    USAGE_DISCREPANCY_ATTACHMENT_UPLOAD,
    DELETE_DISCREPANCY_ATTACHMENT_REQUEST,
    RESET_DISCREPANCY_ATTACHMENT,
    CHECK_IS_PRICEOVERRIDE_PAGE,
    STORE_USAGE_DATA_PERSIST,
    PUT_DISCREPANCY_DATA_REQUEST,
    UPDATE_DIS_ATTACHMENT,
    SET_PROCEDURE_DATA,
    SET_PHYSICIAN_PROCEDURE_DROPDOWN,
    SET_PHYSICIAN_TEXT_DATA,
    SET_SHIP_TO_ADDRESS_DETAILS,
    SET_DISCREPANCY_EMAIL,
    USAGE_SUBMIT_CLICKED,
    SET_DISCREPANCY_USAGE_VALUE_EXISTS,
    GET_ORDER_STATUS_DETAILS,
    SET_IS_CONFIRMATION_BOX_CHECKED,
    REPORT_USG_OBJ,
    RESET_DISCREPANCY_USAGE_DETAILS,
    SET_REPORT_PAYMENT_SCREEN,
    SET_REPORT_PAYMENT_FLAG,
    SET_IS_ERROR_EXIST,
    EDIT_USAGE_DETAILS,
    SET_RETRACTOR_USED_OTHER_FIELD_DATA,
    TOTAL_LEVELS_NUMBER,
    UIV_FIRST_LEVEL_SELECTED,
    LIV_FIRST_LEVEL_SELECTED,
    UIV_LEVEL_ARRAY,
    LIV_LEVEL_ARRAY,
    SET_LEVEL_NUMBER_ARRAY,
    VALIDATE_ACCOUNT,
    RESET_VALIDATE_ACCOUNT,
    SET_PROCEDURE_DATA_JP,
    SET_PROCEDURE_VISIBILITY,
    GET_PROCEDURE_INFO_SUCCESS,
    SET_REQUEST_DELIVERY_DATE,
    GET_TRANSFER_RECIPIENT_METHODS,
    SET_TERRITORY,
    CLEAR_TRANSFER_RECIPIENTS,
    SET_INVALID_ITEM_STATUS,
    SET_UIV_DROPDOWN_VALUE,
    SET_LIV_DROPDOWN_VALUE,
    ADD_PROCEDURE_LEVEL,
    SET_PROCEDURE_LEVEL,
    SET_IS_UIV_SELECTED,
    SET_IS_LIV_SELECTED,
    SET_CURR_UIV_LEVEL,
    SET_CURR_LIV_LEVEL,
    SET_CURR_ROW_ID,
    SET_PREV_PROCEDURE_ROW_LEVELS,
    GET_BARCODE_ITEMS,
    SHOW_INVALID_BARCODE_DETAILS,
    SET_BARCODE_RECEIVE_ITEMS,
    SHOW_INVALID_BARCODE_POPUP,
    RESET_INVALID_BARCODE_DETAILS,
    RESET_BARCODE_ITEMS,
    CHECK_ERROR_FOUND_IN_PROCEDURE_LEVEL,
    RESET_PROCEDURE_DATA,
    CHECK_FIRST_LEVEL_SELECTED,
    CHECK_ERROR_FOUND_IN_FIRST_LEVEL,
    SET_MAZOR_CASE_COVERAGE_VALUE,
    RESET_MAZOR_CASE_COVERAGE_VALUE,
    CHECK_LEVEL_DATA_MODIFIED,
    CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED,
    CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED,
    SET_SURGERY_NUMBER,
    SET_REPLENISHMENT_SURGERY_NUMBER,
    VALIDATE_REPLEN,
    CLEAR_VALIDATE_REPLEN,
    CLEAR_ERROR,
    SET_REPLENISHMENT_SURGERY_DATE,
    SET_PROCEDURE_VALUE,
    VALIDATE_STEALTH_CODE,
    RESET_STEALTH_CASE_COVERAGE_VALUE,
    SET_STEALTH_CASE_COVERAGE_VALUE,
    REPORT_PAYMENT_CLICKED,
    PAGE_LOADER,
} from './types';

export const resetInvalidBarCodeDetails = () => {
    return {
        type: 'RESET_INVALID_BARCODE_DETAILS',
    };
};

export const getBarcodeItems = (payload) => {
    return {
        type: GET_BARCODE_ITEMS,
        payload: payload,
    };
};
export const showInvalidBarcodePoup = (payload) => {
    return {
        type: SHOW_INVALID_BARCODE_POPUP,
        payload: payload,
    };
};
export const invalidBarCodeDetails = (payload) => {
    return {
        type: SHOW_INVALID_BARCODE_DETAILS,
        payload: payload,
    };
};

export const setBarcodeDetails = () => {
    return {
        type: SET_BARCODE_RECEIVE_ITEMS,
        payload: '',
    };
};

export const resetBarcodeDetails = (payload) => {
    return {
        type: RESET_BARCODE_ITEMS,
        payload: payload,
    };
};

export const getValidateAccountDetails = (params) => {
    return {
        type: VALIDATE_ACCOUNT,
        payload: params,
    };
};

export const resetValidateAccountDetails = () => {
    return {
        type: RESET_VALIDATE_ACCOUNT,
    };
};
export const resetReportUsageStates = (resetMyCaseRef) => ({
    type: RESET_REPORT_USAGE_STATES,
    resetMyCaseRef,
});

export const updateDisAttachmentAction = (discrepancyAttachment) => {
    return {
        type: UPDATE_DIS_ATTACHMENT,
        payload: discrepancyAttachment,
    };
};

export const resetValidatedData = () => ({
    type: RESET_VALIDATED_DATA,
});

export const storeSurgeryDetails = (surgeryData) => ({
    type: STORE_SURGERY_DETAILS,
    payload: surgeryData,
});
export const storeSurgeryDete = (surgeryDate) => {
    return {
        type: SET_REPLENISHMENT_SURGERY_DATE,
        payload: surgeryDate,
    };
};

export const storeItemTableData = (itemTableData) => {
    return {
        type: STORE_ITEM_TABLE_DATA,
        payload: itemTableData,
    };
};

export const setSelectAccount = (account) => {
    return {
        type: SET_SELECT_ACCOUNT,
        payload: account,
    };
};

export const fetchUsageDetailsRequest = (queryParams) => ({
    type: GET_USAGE_DETAILS,
    payload: queryParams,
});

export const editUsageDetails = (queryParams) => ({
    type: EDIT_USAGE_DETAILS,
    payload: queryParams,
});

export const setPatientDetails = (patientDetails) => ({
    type: SET_PATIENT_DETAILS,
    payload: { patientDetails },
});

export const setProgressBarStatus = (completedStep) => {
    return {
        type: SET_PROGRESS_BAR_STATUS,
        payload: completedStep,
    };
};
export const storeRequestDeliveryDate = (date) => {
    return {
        type: SET_REQUEST_DELIVERY_DATE,
        payload: date,
    };
};

export const resetProgressBarStatus = () => {
    return {
        type: RESET_PROGRESS_BAR_STATUS,
    };
};

export const setProgressBarCurrentStep = (currentStep) => {
    return {
        type: SET_PROGRESS_BAR_CURRENT_STEP,
        payload: currentStep,
    };
};

export const setProgressBarStateEditMode = (data) => {
    return {
        type: SET_PROGRESS_BAR_EDIT_MODE,
        payload: data,
    };
};

export const createUsageOrderRequest = (
    reportUsageObj,
    clickedBtn
) => ({
    type: CREATE_USAGE_ORDER,
    payload: { reportUsageObj, clickedBtn },
});

export const updateUsageOrderRequest = (
    reportUsageObj,
    clickedBtn
) => ({
    type: UPDATE_USAGE_ORDER,
    payload: { reportUsageObj, clickedBtn },
});

export const resetPoDetails = () => ({
    type: RESET_PO_ATTACHMENT,
    payload: '',
});

export const getPricesForItems = (priceItemsObj) => ({
    type: GET_PRICES_FOR_ITEMS,
    payload: priceItemsObj,
});

export const getDropdownOptionsRequest = (
    dropdownType,
    queryParams,
    salesOrg,
    countryISOCode
) => ({
    type: GET_DROPDOWN_OPTIONS,
    payload: { dropdownType, queryParams, salesOrg, countryISOCode },
});

export const storeDistrictTerritoryPayload = (data) => ({
    type: GET_DISTRICT_TERRITORY,
    payload: data,
});

export const resetDropdownOptionsRequest = (dropdownName) => ({
    type: RESET_DROPDOWN_OPTIONS,
    payload: { dropdownName },
});

export const validateMazorCodeRequest = (
    reqBody,
    mazorXvalidationClickedBtn
) => ({
    type: VALIDATE_MAZOR_CODE,
    payload: { reqBody, mazorXvalidationClickedBtn },
});
export const validateStealthCodeRequest = (reqBody, mazorXvalidationClickedBtn) => ({
    type: VALIDATE_STEALTH_CODE,
    payload: { reqBody, mazorXvalidationClickedBtn },
});

export const getProcedureInfoRequest = (isFrom, data, loading) => ({
    type: GET_PROCEDURE_INFO,
    payload: { isFrom, data, loading },
});

export const validateProductDetails = (reqBody, isForReplen) => ({
    type: VALIDATE_PRODUCT_DETAILS,
    payload: { reqBody, isForReplen },
});

export const clearValidateReplenData = () => ({
    type: CLEAR_VALIDATE_REPLEN,
});

export const validatedReplenData = (products) => ({
    type: VALIDATE_REPLEN,
    payload: products,
});
export const clearError = () => ({
    type: CLEAR_ERROR,
});

export const setInvalidStatus = (status) => ({
    type: SET_INVALID_ITEM_STATUS,
    payload: status,
});
export const validateUnidPlanFeeItems = (reqBody, isForReplen) => ({
    type: VALIDATE_UNID_PLAN_FEE_ITEMS,
    payload: { reqBody, isForReplen },
});

export const validateReplenProducts = (queryParams) => ({
    type: VALIDATE_REPLEN_PRODUCTS,
    payload: queryParams,
});

export const usageAttachmentUpload = (formData) => ({
    type: USAGE_ATTACHMENT_UPLOAD,
    payload: formData,
});

export const getPoImagePreview = (details) => {
    return {
        type: GET_IMAGE_PO_PREVIEW,
        payload: details,
    };
};

export const setPOTissueImageDetails = (data) => {
    return {
        type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
        payload: data,
    };
};

export const setPONonTissueImageDetails = (data) => {
    return {
        type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
        payload: data,
    };
};

export const deleteAttachmentRequest = (id) => ({
    type: DELETE_ATTACHMENT_REQUEST,
    payload: id,
});

export const setLocalSignature = (obj) => ({
    type: 'SET_LOCAL_SIGNATURE',
    payload: obj,
});
export const setAllAccountOwned = (value) => ({
    type: SET_ALL_ACCOUNT_OWNED_SELECTED,
    payload: value,
});

export const setProcedureDetails = (data) => ({
    type: SET_PROCEDURE_DETAILS,
    payload: data,
});

export const setUnidDetails = (data) => ({
    type: SET_UNID_SELECTED,
    payload: data,
});
export const saveOrReportDetails = (data) => ({
    type: SAVE_OR_REPORT_DATA,
    payload: data,
});

export const clearSingleDropDownList = (value) => {
    return {
        type: CLEAR_SPECFIC_DROPDOWN_LIST,
        payload: value,
    };
};

export const resetPoImagePreview = () => {
    return {
        type: RESET_IMAGE_PO_PREVIEW,
    };
};

export const setShowUnsavedReportUsageChangesPopUp = (value, path, screen) => {
    return {
        type: SHOW_UNSAVED_REPORT_USAGE_CHANGES_POP_UP,
        payload: { showPopup: value, navPath: path, selectedScreen: screen },
    };
};

export const setShowNoUsageToReportOrCancelPopup = (noUsageObj) => {
    return {
        type: SHOW_NO_USAGE_OR_CANCEL_SURGERY_POPUP,
        payload: noUsageObj,
    };
};
export const setPriceOverrideDetails = (value) => {
    return {
        type: SET_PRICEOVERRIDE_DETAILS,
        payload: value,
    };
};

export const cancelUsageOrderRequest = (
    cancelUsageObj,
    isCancelWithoutReason,
    isFromOrderDetailsModal
) => ({
    type: CANCEL_USAGE_ORDER,
    payload: { cancelUsageObj, isCancelWithoutReason, isFromOrderDetailsModal },
});

export const getShippingMethods = (payload) => {
    return {
        type: GET_SHIPPING_METHODS_REPORT_USAGE,
        payload,
    };
};

export const setSurgeryNumber = (numberOfSurgeries) => {
    return {
        type: SET_SURGERY_NUMBER,
        payload: numberOfSurgeries,
    };
};
export const setReplenishmentSurgeryNumber = (numberOfSurgeries) => {
    return {
        type: SET_REPLENISHMENT_SURGERY_NUMBER,
        payload: numberOfSurgeries,
    };
};

export const resetRepleneShippingMethods = () => {
    return {
        type: RESET_REPLENE_SHIPPING_METHOD,
    };
};
export const setSelectedOutsideAccount = (payload) => {
    return {
        type: GET_OUTSIDE_ACCOUNT,
        payload,
    };
};
export const clearInsideShippingAddress = () => {
    return {
        type: CLEAR_INSIDE_SHIPPING_ADDRESS,
    };
};
export const clearInsideShippingAddressWhenBillToCleared = () => {
    return {
        type: CLEAR_INSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED,
    };
};
export const clearOutsideShippingAddressWhenBillToCleared = () => {
    return {
        type: CLEAR_OUTSIDE_SHIPPING_ADDRESS_WHEN_BILLTO_CLEARED,
    };
};
export const clearOutsideShippingAddress = () => {
    return {
        type: CLEAR_OUTSIDE_SHIPPING_ADDRESS,
    };
};

export const getShipToAddress = (data) => {
    return {
        type: GET_SHIP_TO_ADDRESS_REPORT_USAGE,
        payload: data,
    };
};

export const setUsageSurgeryInsideAction = (data) => {
    return {
        type: SET_USAGE_SURGERY_DETAIL_INSIDE,
        payload: data,
    };
};
export const setUsageSurgeryOutsideAction = (data) => {
    return {
        type: SET_USAGE_SURGERY_DETAIL_OUTSIDE,
        payload: data,
    };
};
export const getDisparencyData = (object) => {
    return {
        type: GET_DISCREPANCY_DATA,
        payload: object,
    };
};
export const usageDiscrepancyAttachmentUpload = (formData) => ({
    type: USAGE_DISCREPANCY_ATTACHMENT_UPLOAD,
    payload: formData,
});
export const deleteDiscrepancyAttachmentRequest = (object) => ({
    type: DELETE_DISCREPANCY_ATTACHMENT_REQUEST,
    payload: object,
});
export const resetDescrepancyDetails = () => {
    return {
        type: RESET_DISCREPANCY_ATTACHMENT,
        payload: [],
    };
};

export const setPriceOverridePage = (data) => {
    return {
        type: CHECK_IS_PRICEOVERRIDE_PAGE,
        payload: data,
    };
};
export const storeUsageDataPresist = (data) => {
    return {
        type: STORE_USAGE_DATA_PERSIST,
        payload: data,
    };
};

export const putDisparencyData = (object) => {
    return {
        type: PUT_DISCREPANCY_DATA_REQUEST,
        payload: object,
    };
};

export const setProcedureData = (object, name) => {
    return {
        type: SET_PROCEDURE_DATA,
        payload: object,
        // name: name ? name : false,
    };
    
};

export const setProcedureInfo = (name, object) => {
    return {
        type: GET_PROCEDURE_INFO_SUCCESS,
        payload: object,
        name: name ? name : false,
    };
};

export const setProcedureData_JP = (name, object) => {
    return {
        type: SET_PROCEDURE_DATA_JP,
        name: name,
        payload: object,
    };
};
export const setProcedureDataVisibility = (name, value) => {
    return {
        type: SET_PROCEDURE_VISIBILITY,
        name: name,
        payload: value,
    };
};
export const setRetractorUsedOtherField = (data) => {
    return {
        type: SET_RETRACTOR_USED_OTHER_FIELD_DATA,
        payload: data,
    };
};

export const setTotalLevelsNumber = (data) => {
    return {
        type: TOTAL_LEVELS_NUMBER,
        payload: data,
    };
};

export const setUivFirstLevelSelected = (data) => {
    return {
        type: UIV_FIRST_LEVEL_SELECTED,
        payload: data,
    };
};

export const setLivFirstLevelSelected = (data) => {
    return {
        type: LIV_FIRST_LEVEL_SELECTED,
        payload: data,
    };
};

export const setUivLevelArray = (data) => {
    return {
        type: UIV_LEVEL_ARRAY,
        payload: data,
    };
};

export const setLivLevelArray = (data) => {
    return {
        type: LIV_LEVEL_ARRAY,
        payload: data,
    };
};

export const setLevelNumberArray = (data) => {
    return {
        type: SET_LEVEL_NUMBER_ARRAY,
        payload: data,
    };
};

export const setCurrUivLevel = (data) => {
    return {
        type: SET_CURR_UIV_LEVEL,
        payload: data,
    };
};

export const setCurrRowId = (data) => {
    return {
        type: SET_CURR_ROW_ID,
        payload: data,
    };
};

export const setCurrLivLevel = (data) => {
    return {
        type: SET_CURR_LIV_LEVEL,
        payload: data,
    };
};
export const setPhysicianProcedureDropdownValue = (object) => {
    return {
        type: SET_PHYSICIAN_PROCEDURE_DROPDOWN,
        payload: object,
    };
};

export const setPhysicianTextData = (data) => {
    return {
        type: SET_PHYSICIAN_TEXT_DATA,
        payload: data,
    };
};

export const setMazorCaseCoverageValue = (value) => {
    return {
        type: SET_MAZOR_CASE_COVERAGE_VALUE,
        payload: value,
    };
};

export const resetMazxorCaseCoverage = () => {
    return {
        type: RESET_MAZOR_CASE_COVERAGE_VALUE,
    };
};
export const setStealthCaseCoverageValue = (value) => {
    return {
        type: SET_STEALTH_CASE_COVERAGE_VALUE,
        payload: value,
    };
};

export const resetStealthCaseCoverage = () => {
    return {
        type: RESET_STEALTH_CASE_COVERAGE_VALUE,
    };
};

export const setUivDropdownValue = (value) => {
    return {
        type: SET_UIV_DROPDOWN_VALUE,
        payload: value,
    };
};

export const setIsFirstUivSelected = (value) => {
    return {
        type: SET_IS_UIV_SELECTED,
        payload: value,
    };
};

export const setIsFirstLivSelected = (value) => {
    return {
        type: SET_IS_LIV_SELECTED,
        payload: value,
    };
};

export const setLivDropdownValue = (value) => {
    return {
        type: SET_LIV_DROPDOWN_VALUE,
        payload: value,
    };
};

export const addProcedureLevel = (newLevel) => ({
    type: ADD_PROCEDURE_LEVEL,
    payload: newLevel,
});

export const setProcedureLevel = (value) => {
    return {
        type: SET_PROCEDURE_LEVEL,
        payload: value,
    };
};
export const resetLevelData = () => {
    return {
        type: RESET_PROCEDURE_DATA,
    };
};
export const checkIsFirstLevelSelected = (value) => {
    return {
        type: CHECK_FIRST_LEVEL_SELECTED,
        payload: value,
    };
};
export const setProcedureValue = (value) => {
    return {
        type: SET_PROCEDURE_VALUE,
        payload: value,
    };
};
export const checkIsErrorFoundInFirstLevel = (value) => {
    return {
        type: CHECK_ERROR_FOUND_IN_FIRST_LEVEL,
        payload: value,
    };
};
export const setModifiedLevelDataFlag = (value) => {
    return {
        type: CHECK_LEVEL_DATA_MODIFIED,
        payload: value,
    };
};
export const checkIsErrorFoundInProcedureLevel = (value) => {
    return {
        type: CHECK_ERROR_FOUND_IN_PROCEDURE_LEVEL,
        payload: value,
    };
};

export const setPrevProcedureLevels = (value) => {
    return {
        type: SET_PREV_PROCEDURE_ROW_LEVELS,
        payload: value,
    };
};

export const setShippingDetails = (shippingDetails) => {
    return {
        type: SET_SHIP_TO_ADDRESS_DETAILS,
        payload: shippingDetails,
    };
};

export const setDiscrepancyEmailIds = (emailId) => {
    return {
        type: SET_DISCREPANCY_EMAIL,
        payload: emailId,
    };
};

export const setSubmitClicked = (value) => {
    return {
        type: USAGE_SUBMIT_CLICKED,
        payload: value,
    };
};
export const setDiscrepancyUsageValueExist = (emailId) => {
    return {
        type: SET_DISCREPANCY_USAGE_VALUE_EXISTS,
        payload: emailId,
    };
};

export const getOrderStatusDetails = (myCaseRef) => ({
    type: GET_ORDER_STATUS_DETAILS,
    payload: myCaseRef,
});

export const setIsConfirmationChecked = (value) => ({
    type: SET_IS_CONFIRMATION_BOX_CHECKED,
    payload: value,
});

export const setReportUsageFormObject = (object) => ({
    type: REPORT_USG_OBJ,
    payload: object,
});

export const resetDiscrepancyUsageDetails = () => ({
    type: RESET_DISCREPANCY_USAGE_DETAILS,
});

export const setReportPaymentScreenName = (screenName) => ({
    type: SET_REPORT_PAYMENT_SCREEN,
    payload: screenName,
});

export const setReportPaymentFlag = (flag) => ({
    type: SET_REPORT_PAYMENT_FLAG,
    payload: flag,
});

export const setIsErrorExist = (flag) => ({
    type: SET_IS_ERROR_EXIST,
    payload: flag,
});

export const clearTransferRecipients = (data) => {
    return {
        type: CLEAR_TRANSFER_RECIPIENTS,
    };
};

export const getTransferRecipientMethods = (account) => {
    return {
        type: GET_TRANSFER_RECIPIENT_METHODS,
        payload: account,
    };
};

export const setTerritoryValue = (value) => {
    return {
        type: SET_TERRITORY,
        payload: value,
    };
};

export const reportPaymentClicked = (value) => {
    return {
        type: REPORT_PAYMENT_CLICKED,
        payload: value,
    };
};

export const setPageLoader = (loader) => {
    return {
        type: PAGE_LOADER,
        payload: loader,
    };
};